var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoStrikeThrough(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M40.25,21.16h-14.92c-3.74-1.78-5.06-2.93-4.3-5.9,.45-1.73,1.29-2.3,1.89-2.57,2.45-1.12,6.64,.44,8.04,1.14,.99,.49,2.19,.09,2.68-.9,.49-.99,.09-2.19-.89-2.68-.69-.35-6.87-3.31-11.48-1.2-1.43,.65-3.31,2.09-4.11,5.22-.79,3.08-.1,5.26,1.24,6.9H7.74c-1.11,0-2,.89-2,2s.89,2,2,2H24.43c.06,.03,.13,.06,.19,.09,4.05,1.87,6.54,3.18,6.54,6.64,0,1.43-1.24,2.91-3.08,3.69-3.14,1.33-6.88,.31-10-2.72-.79-.77-2.06-.75-2.83,.04-.77,.79-.75,2.06,.04,2.83,2.99,2.91,6.5,4.44,9.92,4.44,1.51,0,3-.29,4.43-.9,3.35-1.42,5.52-4.31,5.52-7.37s-1.21-5.16-2.9-6.73h7.99c1.11,0,2-.89,2-2s-.89-2-2-2Z",
    fill: outlineColor
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.22,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStrikeThrough);
export default __webpack_public_path__ + "static/media/ico-strike-through.f9168c4fdce9c7b1aaa513b2366dc27c.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;